import loadable from '@loadable/component';

const ProhibitedLoadable = loadable(
  () => import(/* webpackChunkName: 'prohibited' */ './Prohibited')
);

const Prohibited = () => <ProhibitedLoadable />;

export default Prohibited;
